import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { IUserSchema } from '../../../interfaces/user/IUserSchema';
import Button from '../../../shared/button';
import SuccessRegisterModal from './modals/SuccessRegisterModal';


const Register = () => {
    const [showRegisterModal, setShowRegisterModal] = useState<boolean>(false)
    const [createError, setCreateError] = useState<string>()
    const dispatch = useAppDispatch();
    const navigate = useNavigate()

    const onGoToLogin = () => {
        navigate('/login')
    }

    const onRequestToRegisterUser = async (data: IUserSchema): Promise<boolean> => {
        const payload = {
            ...data,
        }
        try {
            // await dispatch(tryToAddUser(payload)).unwrap();
            navigate('/login');
            setCreateError(undefined)
            setShowRegisterModal(true)
            return true
        } catch (error) {
            setCreateError(`${error}`)
            return false
        }
    }

    return (
        <div className="md:min-h-screen px-10 py-12">
            <div className="max-w-[330px] m-auto mt-[9%]">
                <h1 className="font-dm_sans_bold text-4xl">Please fill your details</h1>
                <SuccessRegisterModal
                    openModal={showRegisterModal}
                    handleCloseModal={() => setShowRegisterModal(false)}
                />
                <div className="font-dm_sans_regular text-center flex flex-col items-center mt-8">
                    <Button
                        label={'I have an account.'}
                        className={'btn-primary-text !font-normal'}
                        onClickButton={onGoToLogin}
                    />
                </div>
            </div>
        </div>
    )
}

export default Register;